import { CardAction, Grid, GridItem, Text, VerticalSpacer } from "@innovationnorway/lighthouse-components";
import React, { FC, useContext, useEffect, useState } from "react";
import useSWR from "swr";
import { AppContext } from "../../../app-context";
import { AccountTypeEnum } from "../../../main/models/account-type-enum";
import { UserAccount } from "../../../main/models/user-account";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { getUserAccounts } from "../../apis/getUserAccounts";
import ActorContainer from "../../components/actorContainer/actorContainer";
import { GettingStartedCards } from "../../components/gettingStartedCards/gettingStartedCards";
import BetaPage from "../../components/page/betaPage";
import UserTasksSummary from "../../components/userTasksSummary/userTasksSummary";
import { useLayout } from "../../hooks/useLayout";

const BetaHome: FC = () => {
  const { translations } = useLayout();
  const { featureFlags } = useContext(AppContext);

  const [currentAccount, setCurrentAccount] = useState<UserAccount>();
  const { data: userAccounts } = useSWR(`userAccounts`, getUserAccounts);

  useEffect(() => {
    if (translations.applicationTitle && translations.companyName) {
      document.title = `${translations.applicationTitle} - ${translations.companyName}`;
    }
  }, [translations]);

  useEffect(() => {
    if (userAccounts && !currentAccount) {
      const verifiedAccounts = userAccounts?.filter((userAccount) => userAccount.emailVerified === true);
      setCurrentAccountByAccountPublicId(verifiedAccounts?.[0]?.account.publicId || "");
    }
  }, [userAccounts]);

  const setCurrentAccountByAccountPublicId = (publicId: string) => {
    if (publicId === "personal") {
      const personalAccount = userAccounts?.find(
        (userAccount) => userAccount.account.accountType === AccountTypeEnum.NorwegianPerson
      );
      setCurrentAccount(personalAccount);
    } else {
      const account = userAccounts?.find((userAccount) => userAccount.account.publicId === publicId);
      setCurrentAccount(account);
    }
  };

  return featureFlags?.featureBetaModeEnabled ? (
    <BetaPage>
      <VerticalSpacer size="l" />
      <Grid>
        {userAccounts && userAccounts?.length < 2 && currentAccount && currentAccount.applications.length < 1 ? (
          <GettingStartedCards
            fastForwardUrl={currentAccount.fastForwardUrl}
            projectAssistantUrl={currentAccount.projectAssistantUrl}
            small
          />
        ) : (
          <GridItem spanLarge={4} spanMedium={4} spanSmall={2}>
            <VerticalSpacer size="l" />
            <Text variant="lead1">{translations.applicationTitle}</Text>
            <VerticalSpacer size="l" />
            <UserTasksSummary />
          </GridItem>
        )}
      </Grid>
      <Grid>
        <GridItem spanLarge={12} spanMedium={12} spanSmall={4}>
          <VerticalSpacer size="l" />
          <ActorContainer
            setCurrentAccountByAccountPublicId={setCurrentAccountByAccountPublicId}
            currentAccount={currentAccount}
          />
        </GridItem>
      </Grid>
      <VerticalSpacer size="l" />
      <Text variant="lead1">{translations.servicesTitle}</Text>
      <VerticalSpacer size="m" />
      <Grid>
        <GridItem
          spanLarge={3}
          spanMedium={3}
          spanSmall={2}
          onClick={() => sendSiteimproveEvent(`MyPage-coursesBeta`, "coursePageClicked", "Courses button clicked")}
        >
          <CardAction
            variant="tertiary"
            role="sidekick"
            title={translations.coursesPageTitle}
            lead={translations.coursesDescriptionLabel}
            url={currentAccount?.courseUrl || ""}
          />
        </GridItem>
        <GridItem
          spanLarge={3}
          spanMedium={3}
          spanSmall={2}
          onClick={() => sendSiteimproveEvent(`MyPage-financeBeta`, "financeClicked", "Finance button clicked")}
        >
          <CardAction
            variant="tertiary"
            role="sidekick"
            title={translations.financeTitle}
            lead={translations.financeDescription}
            url={currentAccount?.bankingUrl || ""}
          />
        </GridItem>
      </Grid>
    </BetaPage>
  ) : (
    <div>{translations.betaError}</div>
  );
};

export default BetaHome;
